<template>
  <div>
    <v-navigation-drawer
      v-model="showFilters"
      clipped
      :temporary="$vuetify.breakpoint.xsOnly"
      :permanent="$vuetify.breakpoint.smAndUp"
      overflow
      hide-overlay
      app
      :style="{ marginTop: $vuetify.breakpoint.smAndDown ? '64px' : '128px' }"
    >
      <div class="pa-4">
        <div class="display-2 secondary--text mb-3">
          Filters
          <v-btn
            flat
            outline
            round
            color="primary"
            class="no-text-transform"
            @click="selectedFilters = []"
          >
            Clear all
          </v-btn>
        </div>
        <div
          v-for="service in sortedServices(currentTags)"
          :key="service.id"
          class="mb-3"
        >
          <div class="headline secondary--text pb-1">
            {{ service.title }}
          </div>
          <v-checkbox
            v-for="tag in sortedTags(service.tags)"
            :key="tag.id"
            v-model="selectedFilters"
            hide-details
            class="pb-1 ma-0"
            color="primary"
            :label="tag.title"
            :value="tag.title"
          >
            <div slot="label" class="primary--text">
              {{ tag.title }}
            </div>
          </v-checkbox>
        </div>
        <div class="mb-3">
          <div class="headline secondary--text pb-1">
            Location
          </div>
          <v-checkbox
            v-model="selectedFilters"
            hide-details
            class="pb-1 ma-0"
            value="_onbase"
            color="primary"
          >
            <div slot="label" class="primary--text">
              On Fort Meade
            </div>
          </v-checkbox>
          <v-checkbox
            v-model="selectedFilters"
            hide-details
            class="pb-1 ma-0"
            value="_offbase"
            color="primary"
          >
            <div slot="label" class="primary--text">
              Off Fort Meade
            </div>
          </v-checkbox>
        </div>
        <div style="height:100px">
          <!--spacer to ensure back button doesn't cover up checkboxes-->
        </div>
      </div>
    </v-navigation-drawer>
    <v-content>
      <v-container>
        <h1
          :class="[
            this.$vuetify.breakpoint.smAndDown ? 'display-1' : 'display-3',
            'secondary--text',
            'font-weight-bold',
            'pl-4',
            'pt-2'
          ]"
        >
          {{ currentCategory.title }}
        </h1>
        <v-container grid-list-xl fluid>
          <v-layout column>
            <div class="hidden-sm-and-up" :style="{ alignSelf: 'center' }">
              <v-btn color="primary" @click="toggleFilterSideNav">
                Show Filters
              </v-btn>
            </div>
            <v-flex v-for="listing in filteredListings" :key="listing.id">
              <fma-tile
                :title="listing.title"
                :description="listing.description"
                :action-on-tile-click="() => openDialog(listing)"
                line-clamp
              />
            </v-flex>
          </v-layout>
        </v-container>
      </v-container>
      <v-dialog
        v-model="dialogOpen"
        width="75vw"
        content-class="overflow-visible"
      >
        <v-card max-height="75vh">
          <v-card max-height="75vh" style="overflow: auto;">
            <fma-listing :listing="currentDialogData" />
          </v-card>
          <v-btn
            id="close-button"
            icon
            color="primary"
            class="ma-0 fma-round-button"
            @click="dialogOpen = false"
          >
            <v-icon x-large>
              close
            </v-icon>
          </v-btn>
        </v-card>
      </v-dialog>
    </v-content>
    <div
      v-if="kioskMode"
      class="hidden-sm-and-down"
      style="position: fixed; bottom:50px; left:0; z-index:10;"
    >
      <fma-back-button />
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import FmaTile from "@/components/FmaTile.vue";
import FmaListing from "@/components/FmaListing.vue";
import FmaBackButton from "@/components/FmaBackButton.vue";
import { mapState } from "vuex";

export default {
  components: {
    FmaTile,
    FmaListing,
    FmaBackButton
  },
  data() {
    return {
      currentDialogData: {},
      selectedFilters: [],
      dialogOpen: false,
      showFilters: false
    };
  },
  computed: {
    ...mapState({ kioskMode: state => state.kioskMode }),
    filteredListings() {
      return this.sortedListings.filter(listing =>
        this.selectedFilters.every(filter => listing.tags.includes(filter))
      );
    },
    currentCategory() {
      return this.$store.state.currentCategory;
    },
    currentTags() {
      return this.$store.state.tagsByCategory;
    },
    sortedListings() {
      return _.sortBy(this.$store.state.listingsByCategory, listing => {
        return _.toUpper(listing.title);
      });
    },
    tileWidth() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return 12;
        case "sm":
          return 6;
        case "md":
          return 4;
        case "lg":
          return 3;
        case "xl":
          return 3;
        default:
          return 3; //TODO: is this right
      }
    }
  },
  mounted() {
    this.$store.dispatch("fetchCategory", {
      id: this.$route.params.categoryId
    });
    this.$store.dispatch("fetchListingsByCategory", {
      id: this.$route.params.categoryId
    });
    this.$store.dispatch("fetchTagsByCategory", {
      id: this.$route.params.categoryId
    });
  },
  methods: {
    openDialog(listing) {
      //Add google track for looking at a listing
      this.$gtag.screenview({
        app_name: "Fort Meade Resiliency Services",
        screen_name: listing.title
      });

      // update the dialog content to correspond to the tile that was opened
      this.currentDialogData = listing;
      // display the dialog
      this.dialogOpen = true;
    },
    sortedServices(services) {
      return _.sortBy(services, service => _.toUpper(service.title));
    },
    sortedTags(tags) {
      return _.sortBy(tags, tag => _.toUpper(tag.title));
    },
    toggleFilterSideNav() {
      this.showFilters = !this.showFilters;
    }
  }
};
</script>

<style scoped lang="less">
@import "../assets/global.less";

@close-button-radius: 32px;

#close-button {
  position: absolute;
  top: -@close-button-radius;
  right: -@close-button-radius;
  height: 2 * @close-button-radius;
  width: 2 * @close-button-radius;
}

// prevent button text from being automatically capitalized
.no-text-transform {
  text-transform: none;
}
</style>
